import Vue from 'vue';
import lodash from 'lodash';
import Toasted from 'vue-toasted';
import PortalVue from 'portal-vue';
import ToggleButton from 'vue-js-toggle-button';
import Vuelidate from 'vuelidate';
import VueGtm from 'vue-gtm';
import createI18n from '@mobile/i18n';
import startErrorLogging from '@mobile/errorLogging';
import db from '@mobile/db/db';
import { userService } from '@mobile/services/user';
import broadcastService from '@/services/broadcast';
import store from './store';
import createRouter from './router';
import App from './App.vue';
import { eventBus } from '@/eventBus';
import '@mobile/assets/fonts.css';
import '@mobile/assets/main.css';
import './components';
import InteractsWithDates from '@/mixins/InteractsWithDates';
import amplitude from 'amplitude-js';
import config from 'config';
import md5 from 'crypto-js/sha256';
// switched off
// import './registerServiceWorker';

// remove registered service workers
import './unregisterServiceWorker';

window.location.href = 'https://admin.lumiformapp.com/update-app';

startErrorLogging();

amplitude.getInstance().init(config.amplitudeApiKey);

window._ = lodash;
window.i18n = createI18n();

const router = createRouter();

Vue.config.productionTip = false;

Vue.use(Toasted, {
    router,
    theme: 'zyp',
    position: 'bottom-right',
    duration: 6000,
});
Vue.use(VueGtm, {
    id: config.gtmKey, // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: true, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    ignoredViews: [], // Don't trigger events for specified router names (case insensitive) (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});
Vue.use(PortalVue);
Vue.use(ToggleButton);
Vue.use(Vuelidate);
Vue.mixin(InteractsWithDates);

window.addEventListener('online', () => {
    store.commit('connection/setConnectionStatus', true);
    store.dispatch('sync/syncAll');
    store.dispatch('applicationConnected');
});

window.addEventListener('offline', () => {
    store.commit('connection/setConnectionStatus', false);
});

// eslint-disable-next-line no-new
new Vue({
    el: '#app',
    router,
    store,
    i18n: window.i18n,

    computed: {
        user() {
            return this.$store.getters['authentication/user'];
        },
    },

    created() {
        this.user && userService.me()
            .then(async (user) => {
                this.$store.commit('authentication/setUser', user)
                this.pushDataLayer(user);
            });

        if (this.$store.getters['authentication/user']) {
            this.$store.dispatch('applicationConnected');
            broadcastService.start(this.$store);
        }

        eventBus.$on('login', (user) => {
            this.$store.dispatch('applicationConnected');
            broadcastService.start(this.$store);
            this.pushDataLayer(user);

            if (this.$route.query.nextUrl) {
                this.$router.push(this.$route.query.nextUrl);
            } else {
                this.$router.push('/');
            }
        });

        eventBus.$on('logout', async () => {
            broadcastService.end();
            await db.open();
            await db.clear();
            this.pushDataLayer();
            this.$router.push('/login');
        });

        eventBus.$on('error', (message) => {
            this.$toasted.show(message, { type: 'error' });
        });

        eventBus.$on('newVersion', (registration) => {
            const message = window.i18n.t('New version available');
            this.$toasted.show(message, {
                action: {
                    onClick: () => {
                        console.log('clicked on update');
                        console.log('checking if the page is controlled by service worker');
                        if (navigator.serviceWorker.controller) {
                            console.log('it is, so post skipWaiting message');
                            registration.waiting.postMessage({
                                action: 'skipWaiting',
                            });
                        }
                        console.log('reload page');
                        this.$nextTick(() => window.location.reload(true));
                    },
                    text: window.i18n.t('Update & Reload'),
                },
                duration: null,
            });
        });
    },

    methods: {
        /* eslint-disable no-nested-ternary */
        pushDataLayer(user = null) {
            this.$gtm.dataLayer().push({
                event: 'userDataSet',
                userID: !user ? null : user.analytics ? user.analytics.id : md5(user.id),
                userName: !user ? null : user.name,
                userEmail: !user ? null : user.email,
                userLanguage: !user ? null : user.locale ? user.locale : null,
                organizationID: !user ? null : md5(user.organization_id.toString()).toString(),
                subscriptionPlan: !user ? null : user.subscription ? user.subscription.name : null,
                subscriptionInterval: !user ? null : user.subscription ? user.subscription.interval : null,
                subscriptionStatus: !user ? null : user.subscription ? user.subscription.status : null,
                onFreePlan: !user ? null : user.subscription && user.subscription.is_free,
                completedInspections: !user ? null : user.analytics ? user.analytics.completed_inspections : 0,
                createdIssues: !user ? null : user.analytics ? user.analytics.issues_created : 0,
            });
        },
    },

    render: (h) => h(App),
});
